import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ListTableBody from '../../../components/list-table-body/list-table-body.componenet';
import ListHeader from '../../../components/list-header/list-header.component';

import { WORK_ORDERS_COLUMNS } from './work-orders-columns.data';
import { LOCAL_FILTER_FIELDS } from './work-orders-local-filter-filters.data';
import { setListType, setLoadedData, setPagePath } from '../../../redux/list/list.actions';
import { setDetailPagePath } from '../../../redux/detail/detail.actions';
import { setFilterEmpty } from '../../../redux/filter/filter.actions';
import { selectListType } from '../../../redux/list/list.reselect';
import { withRouter } from 'react-router-dom';
import { setIsEditByFullForm } from '../../../redux/form/form.actions';
import { useState } from 'react';
import { setTabTitle } from '../../../utils/tab-title.utils';
import { selectAccessRights } from '../../../redux/user/user.reselect';

const APP_NAME = `work_order`

const TYPE = {
    WORK_ORDERS: "WORK_ORDERS",
}

const WorkOrdersList = ({
    setListType,
    setLoadedData,
    setModalType,
    setFilterEmpty,
    listType,
    history,
    setIsEditByFullForm,
    setPagePath,
    accessRights
}) => {
    const [confrimLoadedData, setConfirmLoadedData] = useState(false);
    const [isAccessRightChecked, setIsAccessRightCheked] = useState(false);
    const isViewOnly = useRef(false);

    const endpoint = "/workorders";
    const pagePath = "/work-orders"

    const handleAddWorkOrder = () => {
        history.push(`${pagePath}/new`);
    }

    useEffect(() => {
        const accessRight = accessRights.find((accessRight => {
            return accessRight.application.toLowerCase() === APP_NAME && APP_NAME.toLowerCase()
        }))

        if (accessRight && (accessRight.permission.toLowerCase() === "view only")) {
            isViewOnly.current = true;
        }

        setIsAccessRightCheked(true)
    }, [])

    useEffect(() => {
        if (listType !== TYPE.WORK_ORDERS) {
            setLoadedData({ data: null, skip: null, totalNumItems: 0 });
            setFilterEmpty();
        }

        setListType(TYPE.WORK_ORDERS);
        setPagePath(pagePath);
        setIsEditByFullForm(true);
        setConfirmLoadedData(true);
    }, [])

    useEffect(() => {
        return () => {
            setIsEditByFullForm(false);
            setPagePath(null);
        }
    }, [])

    useEffect(() => {
        setTabTitle(`Work Order`)
    }, [])

    return (
        isAccessRightChecked && confrimLoadedData &&
        <>
            <ListHeader
                buttonAction={handleAddWorkOrder}
                buttonActionLabel={"Add Work Order"}
                endpoint={endpoint}
                title={"Work Orders"}
                isViewOnly={isViewOnly.current}
            />
            <ListTableBody
                tableColumns={WORK_ORDERS_COLUMNS}
                localFilterFields={LOCAL_FILTER_FIELDS}
                endpoint={endpoint}
            />
        </>
    )
};

const mapStateToProps = createStructuredSelector({
    listType: selectListType,
    accessRights: selectAccessRights
})

const mapDispatchToProps = (dispatch) => ({
    setListType: (listType) =>
        dispatch(setListType(listType)),
    setLoadedData: (data) =>
        dispatch(setLoadedData(data)),
    setFilterEmpty: () =>
        dispatch(setFilterEmpty()),
    setIsEditByFullForm: (data) =>
        dispatch(setIsEditByFullForm(data)),
    setPagePath: (data) =>
        dispatch(setPagePath(data))
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkOrdersList))